import type Store from "@ember-data/store";
import type HealthCentre from "parog-web/models/health-centre";

/**
 * Loads the valid identity documents of the given health centres, with one
 * request. Health centres whose list is already loaded are skipped, so a
 * page reload is needed to see a new configuration.
 */
export async function loadValidIdentityDocuments(
  store: Store,
  healthCentres: readonly (HealthCentre | null | undefined)[]
): Promise<void> {
  const healthCentreIds = new Set(
    healthCentres
      .filter(
        (healthCentre): healthCentre is HealthCentre =>
          !!healthCentre && healthCentre.validIdentityDocuments.length === 0
      )
      .map(healthCentre => healthCentre.id)
  );
  if (healthCentreIds.size === 0) return;

  await store.query("valid-identity-document", {
    filter: { "health-centre": [...healthCentreIds].join(",") }
  });
}
